import React, { PureComponent } from 'react';
import './ScrollCTA.module.css';

class ScrollCTA extends PureComponent {
  render() {
    const { ctaText } = this.props;
    return (
      <div styleName="scroll-icon-box">
        <i styleName="mouse">
          <i styleName="scroll" />
        </i>
        <p>{ctaText}</p>
      </div>
    );
  }
}

export default ScrollCTA;
